import { put } from '../utils/axios/https';

/*
 * Adelanto NEX — HTTP services (V2 doc §13).
 *
 * Flow: PUT iniciarpago → FE signs transactionDetails → PUT broadcastpago.
 */
export default {
    iniciarAdelantoPago: (body) => put('api/volumen/adelanto/iniciarpago/', body),

    broadcastAdelantoPago: (body) => put('api/volumen/adelanto/broadcastpago/', body),
};
